export const mortgageCalculatorsPage = {
   headerImg: 'mortgage-calculators-heading-image',
   headerTitle: 'mortgage-calculators-heading-text',
   headerFirstParagraph: 'mortgage-calculators-first-paragraph',
   headerSecondParagraph: 'mortgage-calculators-second-paragraph',

   mortgageCalculatorsTiles: 'mortgage-calculators-page-tile-link',
   rateChangeCalculatorLink: 'mortgage-calculators-rate-change-calculator-link',
   mortgagePaymentCalculatorLink: 'mortgage-calculators-payment-calculator-link',
}